export default __webpack_public_path__ + "static/Avisos-c4ac7edd0021cd53e6ea44b56dbeede0.png";